export default __webpack_public_path__ + "5e78d253a1c8551f78da0bfc74735b90.png";